// extracted by mini-css-extract-plugin
export var adjacentSlide = "_on-9";
export var arrowButtonContainer = "_on-5";
export var arrowButtonIcon = "_on-6";
export var carouselArrowButton = "_on-2";
export var carouselElementContainer = "_on-1";
export var currentSlide = "_on-8";
export var left = "_on-3";
export var otherSlide = "_on-a";
export var productCarouselContainer = "_on-0";
export var right = "_on-4";
export var sliderOverflow = "_on-7";